import { Fragment } from "react";

import { Breadcrumbs, PageHeader, Spinner } from "@dzambalaorg/mui-page-layout";
import { emptyStateString } from "@dzambalaorg/draft-js-utils";
import { useFetchData } from "@dzambalaorg/react-hooks";
import type { IContract } from "@framework/types";

import { ContractContent, CraftContactPanel } from "../../../../components";
import { Erc998TemplateList } from "../template-list";

export const Erc998Contract = () => {
  const {
    data: selected = {
      title: "",
      description: emptyStateString,
    } as IContract,
    isLoading,
  } = useFetchData<IContract>(`/erc998/contracts`); // We don't use the id because it's embedded in the hook request.

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <Fragment>
      <Breadcrumbs path={["dashboard", "erc998", "erc998.contract"]} data={[{}, {}, selected]} />

      <PageHeader message="pages.erc998.contract.title" data={selected}>
        <CraftContactPanel contract={selected} />
      </PageHeader>

      <ContractContent contract={selected} />

      <Erc998TemplateList embedded />
    </Fragment>
  );
};
